<app-layout>
  <app-voltar route="listagem/estacionamento-tpg" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>
        Saída de Estacionamento de Tampas, Grades e Paletes
      </app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form">
      <app-subtitulo>
        Informe os dados do caminhão que realizará a retirada dos itens
      </app-subtitulo>
      <div class="formList">
        <app-input
          type="text"
          label="Placa do Cavalo"
          name="TX_PLCA_CAVA"
          formControlName="TX_PLCA_CAVA"
          placeholder="Digite aqui"
          mask="AAA-0A00"
          (blurEvent)="setForms()"
          [requiredInput]="true"></app-input>
        <app-input
          type="number"
          label="N° do Agendamento"
          name="FK_AGND"
          formControlName="FK_AGND"
          placeholder="Digite aqui"
          (blurEvent)="getAgendamentoOrCavalo()"
          mask="0000"></app-input>
        <app-input
          type="disabled"
          label="Motorista"
          name="NM_MTRT"
          formControlName="NM_MTRT"
          placeholder="Aguardando"
          [disabled]="true"></app-input>
        <app-select-check
          type="select"
          label="Carreta(s) que receberá(ão) os itens"
          [placeholder]="carretasSelecionadas"
          (ngModelChange)="onCarretaChange($event)"
          [selectData]="carretaOptions"
          [requiredInput]="true"
          [disabled]="isViewing"></app-select-check>
      </div>
      <app-subtitulo>
        Informações relacionadas aos itens armazenados
      </app-subtitulo>
      <div class="formList">
        <app-input
          type="text"
          label="Placa de uma da(s) carreta(s) que realizou o depósito"
          name="TX_PLCA_CRRT"
          formControlName="TX_PLCA_CRRT"
          placeholder="Digite aqui"
          mask="AAA-0A00"
          (blurEvent)="getMovimentacaoPaleteByPlacaCarreta()"
          [requiredInput]="true"></app-input>
        <span></span>
        <app-input
          type="select"
          label="Item"
          name="NU_ITEM_MOVM"
          formControlName="NU_ITEM_MOVM"
          (ngModelChange)="onItemChange($event)"
          [selectData]="itemOptions"
          [requiredInput]="true"
          [disabled]="true"></app-input>
        <app-input
          type="number"
          label="Quantidade Movimentada"
          name="QT_MOVM_PLTE"
          formControlName="QT_MOVM_PLTE"
          placeholder="Digite aqui"
          [requiredInput]="true"
          [disabled]="true" />
        <app-input
          type="textarea"
          class="grid-2fr"
          label="Observação"
          name="TX_OBSV_MOVM_PLTE"
          formControlName="TX_OBSV_MOVM_PLTE"
          placeholder="Digite aqui"></app-input>
      </div>
      <app-botao
        *ngIf="!isViewing"
        type="cadastro"
        text="Registrar Saída"
        class="botao-cadastro"
        (click)="postPalete()"
        [disabled]="!form.valid"></app-botao>
    </form>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
